<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <!-- Title -->
          <h4 class="text-black fw-bold mb-0 text-center">
            {{ success ? "Cuenta activada" : "Activar tu cuenta" }}
          </h4>

          <p
            v-if="!success"
            class="mb-0 fs-md-15 fs-lg-16 text-paragraph text-center sub-text"
          >
            Crea tu nueva contraseña para activar tu cuenta.
          </p>

          <!-- Alerts -->
          <div v-if="error" class="alert alert-danger mt-15 mb-0">
            {{ error }}
          </div>

          <div v-if="success" class="alert alert-success mt-15 mb-0">
            Tu cuenta ahora está activa. Puedes iniciar sesión con tu nueva contraseña.
          </div>

          <!-- If token missing -->
          <div v-if="!token && !success" class="alert alert-warning mt-15 mb-0">
            Falta el token de activación. Por favor, abre el enlace desde tu correo electrónico nuevamente.
          </div>

          <!-- Form -->
          <form v-if="!success" class="mt-15" @submit.prevent="handleSubmit">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Contraseña</label>
              <input
                v-model.trim="password"
                type="password"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="**************"
                autocomplete="new-password"
                :disabled="isSubmitting || !token"
              />
              <small v-if="password && password.length < 8" class="text-danger">
                Contraseña debe tener al menos 8 caracteres.
              </small>
            </div>

            <div class="form-group mb-15 mb-sm-20">
              <label class="d-block text-black fw-semibold mb-10">
                Confirmar Contraseña
              </label>
              <input
                v-model.trim="confirmPassword"
                type="password"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="**************"
                autocomplete="new-password"
                :disabled="isSubmitting || !token"
              />
              <small
                v-if="confirmPassword && password !== confirmPassword"
                class="text-danger"
              >
                Contraseñas no coinciden.
              </small>
            </div>

            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100"
              type="submit"
              :disabled="!canSubmit || isSubmitting"
            >
              {{ isSubmitting ? "Activando..." : "Activar cuenta" }}
            </button>

            <div class="text-center mt-15 mt-sm-20 mt-md-25">
              <router-link
                to="/login"
                class="link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
              >
                <i class="ph-bold ph-arrow-left"></i>
                Regresar al inicio de sesión
              </router-link>
            </div>
          </form>

          <!-- Success footer -->
          <div v-if="success" class="text-center mt-15 mt-sm-20 mt-md-25">
            <router-link
              to="/login"
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-inline-block px-4"
            >
              Ir a Iniciar Sesión
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/api/Authentication/AuthenticationService";

export default {
  name: "ActivateAccount",
  data() {
    return {
      token: "",
      password: "",
      confirmPassword: "",
      isSubmitting: false,
      error: "",
      success: false,
    };
  },
  computed: {
    canSubmit() {
      if (!this.token) return false;
      if (!this.password || !this.confirmPassword) return false;
      if (this.password.length < 8) return false;
      if (this.password !== this.confirmPassword) return false;
      return true;
    },
  },
  created() {
    // token is in: #/activate?token=XYZ
    const t = this.$route?.query?.token;
    this.token = typeof t === "string" ? t : "";
  },
  methods: {
    async handleSubmit() {
      this.error = "";

      if (!this.canSubmit) {
        this.error =
          "Please provide a valid password (min 8 chars) and confirm it correctly.";
        return;
      }

      this.isSubmitting = true;

      try {

        const payload = {
          token: this.token,
          newPassword: this.password,
        };

        const resp = await AuthenticationService.activateAccount(payload);

        if (!resp.success) {
          // WebApi often returns plain text on BadRequest("...")
          const text = await resp.text();
          this.error = text || "Activation failed.";
          return;
        }

        this.success = true;

        // Optional: auto-redirect after a few seconds
        // setTimeout(() => this.$router.push("/login"), 2500);
      } catch (e) {
        this.error = "Network error. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
